import { connect } from 'react-redux'

import LoginPage, { IStateProps, IDispatchProps, IOwnProps } from './LoginPage'
import { IStoreState } from '../../services/store/IStoreState'

function mapStateToProps(state: IStoreState): IStateProps {
  return {
    isLogged: state.Auth.isLogged,
  }
}

function mapDispatchToProps(): IDispatchProps {
  return { }
}

export default connect<IStateProps, IDispatchProps, IOwnProps, IStoreState>(
  mapStateToProps,
  mapDispatchToProps
)(LoginPage)
